import { render, staticRenderFns } from "./ContentBuilder.vue?vue&type=template&id=5bb46024&"
import script from "./ContentBuilder.js?vue&type=script&lang=js&"
export * from "./ContentBuilder.js?vue&type=script&lang=js&"
import style0 from "./ContentBuilder.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports